<template>
  <div class="employDetail">
    <el-form :model="formData" size="small" label-width="130px" class="form-horizontal detail-form detail-text-form" style="margin-bottom: 10px;">
      <el-form-item prop="name" label="中心名称：" >
        {{formData.name}}
      </el-form-item>
      <el-form-item  prop="regionId" label="部署区域：" >
        {{formData.provinceName}} {{formData.cityName}} {{formData.regionName}}
      </el-form-item>
      <el-form-item  prop="pushIp" label="IP地址：" >
        {{formData.pushIp}}
      </el-form-item>
      <el-form-item  prop="pushAccount" label="FTP账号："  >
        {{formData.pushAccount}}
      </el-form-item>
      <el-form-item  prop="pushPort" label="FTP端口："  >
        {{formData.pushPort}}
      </el-form-item>
      <el-form-item  prop="expand" label="备注："  >
        {{formData.expand}}
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
export default {
  name: 'dataPushDetail',
  mixins: [tableMix],
  components: { RTable },
  data() {
    let detailKeys = ['name','pushIp','provinceName','cityName','regionName','pushAccount','pushPassword','pushPort','expand',]
    let formData = {}
    detailKeys.map((key)=>{
      formData[key] = ''
    })
    return {
      activeNames:['1','2','3','4','5','6'],
      item:{value:'aaa'},
      formData:formData,
    }
  },
  props: {
    selOptions: {
      type: Object,
      default:{cyzjdm:[],rylx:[]}
    },
    detailModal: { type: Boolean, default: false },
    detailData: { type: Object, default: {} },
  },
  watch:{
    detailModal(val) {
      if(val===false){
        return false
      }
      this.initFormData()
    }
  },
  created() {
    this.initFormData()
  },
  methods: {
    initFormData() {
      let tmpData = {}
      for( let key in this.detailData){
        tmpData[key] = (this.detailData[key] || key=='cityName' || key=='regionName') ? this.detailData[key]:'--'
      }

      this.formData = {...tmpData}
    }
  }
}
</script>

<style lang="less" scoped>
  .detail-form{
     display: flex;
     flex-wrap: wrap
   }

  .employeeTable /deep/ .cell.col-is-required:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
</style>
